import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils";

const getArticleTagsApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}article/fetch-tags-list-for-articles`,
    method: "get",
    params: params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getDoctorToken()}`,
    },
  });

  return response;
};

export default getArticleTagsApi;
